module.exports = new __parcel__URL__("create-field.1c1852cf.gif").toString();